module.exports = __webpack_public_path__ + "3_17_13_21_27/img/login-bj.46c4975.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login-bj.png
// module id = Homl
// module chunks = 1